import type { FaireProductEntity } from "../../entity_types/product";

export const p_v4qhkd8x8h: FaireProductEntity = {
  token: "p_v4qhkd8x8h",
  type: "product",
  name: "Puka Shell Choker Necklace - Silver Keone",
  brandName: "Ke Aloha Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/4a2c51f2ec804cc7c815e24d343cde094c463528f83d54f0f4e4bda58fde1bda.jpeg",
  priceDollars: 95,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/b45f4c4f9c4b1a7859fe649c22b242b216113607dda053dff4490c4f0c1bf552.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
